import { render, staticRenderFns } from "./SingleSubmission.vue?vue&type=template&id=22caeb9a&"
import script from "./SingleSubmission.vue?vue&type=script&lang=js&"
export * from "./SingleSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports